export default "__VITE_ASSET__9e3f23bc__"